import { render, staticRenderFns } from "./DataTableExpandableRow.vue?vue&type=template&id=36e300cf&scoped=true"
import script from "./DataTableExpandableRow.vue?vue&type=script&lang=js"
export * from "./DataTableExpandableRow.vue?vue&type=script&lang=js"
import style0 from "./DataTableExpandableRow.vue?vue&type=style&index=0&id=36e300cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e300cf",
  null
  
)

export default component.exports